import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatSort} from '@angular/material/sort';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {MatSelectionListChange} from "@angular/material/list";
import {NICESkill} from "../../models/NICE_Skill.model";

@Component({
    selector: 'app-select-skill-dialog',
    templateUrl: './select-skill-dialog.component.html'
})
export class SelectSkillDialogComponent implements OnInit {

    title: string;  // set by calling component
    message: string;
    skillList: NICESkill[] = [];
    query: string;
    addedSkills: NICESkill[] = [];
    dataSource: MatTableDataSource<NICESkill> = new MatTableDataSource();
    displayedColumns: string[] = ['select', 'mediaTypeIcon', 'skillName', 'campaignName'];
    selection = new SelectionModel<NICESkill>(true, []);
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    filterObj: { searchString: string; showAll: boolean } = {searchString: '', showAll: false};


    constructor(public dialogRef: MatDialogRef<SelectSkillDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: SelectSkillDialogModal) {

    }
    ngOnInit(): void {
        this.skillList = this.data.skillList;
        this.applyFilter();
    }
    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(this.selection.selected);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    applyFilter(event?: Event): void {
        if (event) {
            const filterValue = (event.target as HTMLInputElement).value;
            this.filterObj.searchString = filterValue.trim().toLowerCase();
        }
        this.dataSource.filter = JSON.stringify(this.filterObj);
    }
    isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.filteredData.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(): void {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.filteredData.forEach(row => this.selection.select(row));
    }

    toggleActive($event: MatSlideToggleChange): void {
        this.filterObj.showAll = $event.checked;
        if ($event.checked) {
            this.displayedColumns = ['select', 'mediaTypeIcon', 'skillName', 'isActive'];
        }else{
            this.displayedColumns = ['select', 'mediaTypeIcon', 'skillName'];
        }
        this.applyFilter();

    }

    onSelectionChange(selection: MatSelectionListChange) {
        selection.options[0].selected ?
            this.selection.select(selection.options[0].value) :
            this.selection.deselect(selection.options[0].value);
    }
}

export class SelectSkillDialogModal {
    constructor(
        public skillList: NICESkill[] = [],
        public type: string
    ) {
    }
}


